module.exports = __webpack_public_path__ + "static/media/clipboard-prescription.e1589783.svg";